// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"fa99e168","73":"6c83d55a","450":"ee9db51e","481":"752bd6be","547":"aa9af9e2","796":"6d32667b","841":"9408d4b8","946":"65e28733"}[chunkId] + ".css";
};